import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, User, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

export default function Navbar() {
  const { count } = useCart();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/", label: "Home" },
    { to: "/shop", label: "Shop" },
  ];

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b border-[#e5e5e5]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="logo-link"
          className="font-serif text-3xl tracking-tight leading-none"
        >
          Nesta
        </Link>

        <nav className="hidden md:flex items-center gap-10 text-sm tracking-luxe uppercase">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="hover:opacity-50 transition-opacity"
            >
              {l.label}
            </Link>
          ))}
          {user?.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin" className="hover:opacity-50 transition-opacity">
              Admin
            </Link>
          )}
        </nav>

        <div className="flex items-center gap-5">
          {user ? (
            <div className="hidden md:flex items-center gap-4 text-sm">
              <Link to="/account" data-testid="nav-account" className="hover:opacity-50 flex items-center gap-2">
                <User size={18} /> {user.name.split(" ")[0]}
              </Link>
              <button
                data-testid="logout-btn"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                className="text-[#666] hover:text-black"
              >
                Logout
              </button>
            </div>
          ) : (
            <Link
              to="/login"
              data-testid="nav-login"
              className="hidden md:flex items-center gap-2 text-sm hover:opacity-50"
            >
              <User size={18} /> Account
            </Link>
          )}

          <Link to="/cart" data-testid="nav-cart" className="relative">
            <ShoppingBag size={20} />
            {count > 0 && (
              <span
                data-testid="cart-count"
                className="absolute -top-2 -right-2 bg-[#1a1a1a] text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full"
              >
                {count}
              </span>
            )}
          </Link>

          <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#e5e5e5] bg-white px-6 py-6 flex flex-col gap-4 text-sm uppercase tracking-luxe">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}>
              {l.label}
            </Link>
          ))}
          {user?.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)}>Admin</Link>}
          {user ? (
            <>
              <Link to="/account" onClick={() => setOpen(false)}>Account</Link>
              <button className="text-left" onClick={() => { logout(); setOpen(false); }}>Logout</button>
            </>
          ) : (
            <Link to="/login" onClick={() => setOpen(false)}>Login</Link>
          )}
        </div>
      )}
    </header>
  );
}
